// src/app/guards/bo-client.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, UrlTree } from '@angular/router';
import { createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

const REQUIRED_ROLE = 'ROLE_BACKOFFICE_USER';
const REQUIRED_AUDIENCE = 'sigmap-bo';

export const boClientGuard: CanActivateFn = createAuthGuard(async (): Promise<boolean | UrlTree> => {
  const keycloak: Keycloak.KeycloakInstance = inject(Keycloak);

  if (!keycloak.authenticated) {
    return false;
  }

  const token = keycloak.tokenParsed;

  const realmRoles = token?.realm_access?.roles || [];
  const resourceRoles = Object.values(token?.resource_access || {}).flatMap(client => client.roles || []);

  const allRoles = [...new Set([...realmRoles, ...resourceRoles])]; // tableau plat unique

  const hasRole = allRoles.includes(REQUIRED_ROLE);

  const tokenParsed = keycloak.tokenParsed;

  const aud = tokenParsed?.aud;

  const validAudience = Array.isArray(aud) ? aud.includes(REQUIRED_AUDIENCE) : aud === REQUIRED_AUDIENCE;

  if (!hasRole || !validAudience) {
    await keycloak.logout({ redirectUri: window.location.origin + '/' });
    return false;
  }

  return true;
});
